module.exports = __webpack_public_path__ + "img/ÜbenJugendflamme2.868420f7.jpg";